exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".print-pick-code{width:300px;position:fixed;right:10px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", ""]);

// exports
